import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import ServerStatusWidget from './ServerStatusWidget';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Cause and Impact</h4>
          <p className="legal-text">
            Cause and Impact, Inc. (EIN: 32-0977089) is a 501(c)(3) tax-exempt organization fully recognized by the IRS. 
            Contributions are tax-deductible to the full extent permitted by law.
          </p>
          <p className="disclosure">
            A copy of our latest financial report may be obtained by writing to Cause and Impact, Inc. 
            at our address. Residents of the following states may obtain financial information 
            directly from their respective state agencies: California, Florida, Illinois, Maryland, 
            Massachusetts, Michigan, New Jersey, New York, Pennsylvania, Virginia, Washington, 
            and Wisconsin. Registration with these states does not imply endorsement.
          </p>
        </div>

        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            <a href="https://linkedin.com/cause-and-impact" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <span className="social-icon linkedin"></span>
            </a>
            <a href="https://facebook.com/causeandimpact" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <span className="social-icon facebook"></span>
            </a>
            <a href="https://instagram.com/causeandimpact" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <span className="social-icon instagram"></span>
            </a>
          </div>
          
          {/* Server Status Widget */}
          <div className="server-status-container">
            <ServerStatusWidget />
          </div>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <address>
            <p>841 Virginia Parkway</p>
            <p>STR 103 #153</p>
            <p>McKinney, TX 75071</p>
            <p>Email: info@causeandimpact.org</p>
          </address>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Cause and Impact, Inc. All rights reserved.</p>
       
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/financials">Annual Reports</Link>
        </div>
      </div>

      <div className="footer-message">
        <p className="footer-signature">
          Love our site? Built in-house with passion and purpose — 
          <span className="footer-signature-highlight">No donor dollars spent, because every dollar belongs with the Causes, not the code. 💝</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
